var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "mandatory-weighing-event-config"
  }, [_c('div', {
    staticClass: "animated fadeInDown"
  }, [_c('fieldset', [_c('div', {
    staticClass: "card-body1",
    staticStyle: {
      "margin-bottom": "0.5%",
      "background-color": "white"
    }
  }, [_c('legend', [_vm._v("Mandatory Weighing — Event Rules")]), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.lmSyncMessage) ? _c('p', {
    staticClass: "lm-sync-note"
  }, [_vm._v(_vm._s(_vm.lmSyncMessage))]) : _vm._e()]), _vm._v(" "), _c('b-card', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Event")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Default (Hub Enable)")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Exception (Hub Warning)")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Active")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Action")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.eventRows), function(row) {
    return _c('tr', {
      key: row.eventKey
    }, [_c('td', {
      staticClass: "text-center"
    }, [_vm._v("\n                  " + _vm._s(_vm.eventLabel(row.eventKey)) + "\n                  "), _c('div', {
      staticClass: "event-key-muted"
    }, [_vm._v(_vm._s(row.eventKey))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (row.defaultAction),
        expression: "row.defaultAction"
      }],
      staticClass: "form-control action-select",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(row, "defaultAction", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.actionOptions), function(opt) {
      return _c('option', {
        key: row.eventKey + '-d-' + opt.value,
        domProps: {
          "value": opt.value
        }
      }, [_vm._v("\n                      " + _vm._s(opt.label) + "\n                    ")])
    }), 0)]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (row.exceptionAction),
        expression: "row.exceptionAction"
      }],
      staticClass: "form-control action-select",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(row, "exceptionAction", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.actionOptions), function(opt) {
      return _c('option', {
        key: row.eventKey + '-e-' + opt.value,
        domProps: {
          "value": opt.value
        }
      }, [_vm._v("\n                      " + _vm._s(opt.label) + "\n                    ")])
    }), 0)]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "checkbox"
    }, [_c('label', {
      staticStyle: {
        "font-size": "1em"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (row.isActive),
        expression: "row.isActive"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(row.isActive) ? _vm._i(row.isActive, null) > -1 : (row.isActive)
      },
      on: {
        "change": function($event) {
          var $$a = row.isActive,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(row, "isActive", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(row, "isActive", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(row, "isActive", $$c)
          }
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "cr",
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_c('i', {
      staticClass: "cr-icon fa fa-check"
    })])])])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('button', {
      staticClass: "common-success",
      attrs: {
        "type": "button",
        "disabled": _vm.savingEventKey === row.eventKey
      },
      on: {
        "click": function($event) {
          return _vm.updateEventRow(row)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(_vm.savingEventKey === row.eventKey ? 'Saving...' : 'UPDATE') + "\n                  ")])])])
  }), _vm._v(" "), (!_vm.isLoading && _vm.eventRows.length === 0) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("No event rules found. Run HUB-8234 DB script on HubOps API.")])]) : _vm._e()], 2)])])], 1)], 1)])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "config-help"
  }, [_vm._v("\n          Global rules applied when hub mandatory weighing is "), _c('strong', [_vm._v("Enable")]), _vm._v(" (Default column)\n          or "), _c('strong', [_vm._v("Warning")]), _vm._v(" (Exception column). Hub-level flags are configured under\n          Restrict Temp Inscan on Hub.\n        ")])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e1129e4","hasScoped":true}!./src/views/components/MandatoryWeighingEventConfig/MandatoryWeighingEventConfig.html
// module id = 1733
// module chunks = 2